import { array, date, object, string } from 'yup';

const ERROR_MESSAGE = 'Este campo es obligatorio';

export const FormSchema = object({
  service: string().required(ERROR_MESSAGE),
  gender: string().required(ERROR_MESSAGE),
  mode: string().required(ERROR_MESSAGE),
  contactMethod: array().min(1, 'Debes de seleccionar al menos una opción'),
});